<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="table-container">
  <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
    <div class="">
      <div class="search-container">
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue">
      </div>
    </div>

    <div class="">
      <div class="d-flex gap-2 action-buttons-container">
        <div *ngIf="trainingData.saveButtonForTraining"
          class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addContentFunc()"
          (keydown.enter)="addContentFunc()" matTooltip="Add Content">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')"
          (keydown.enter)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
          (keydown.enter)="openAuditTrail('overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="callReorderFunc()" (keydown.enter)="callReorderFunc()" matTooltip="Refresh Grid"
          *ngIf="trainingData.saveButtonForTraining">
          <img src="../../../assets/img/training_module/Order.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reorder</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshContentGrid()" (keydown.enter)="refreshContentGrid()" matTooltip="Refresh Grid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>

  <table class="dynamic-table-container documentTable">
    <th style="min-width: 60px; text-align: center;"
      [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
      <div style="display: flex;">
        <div>
          <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
        </div>
      </div>
    </th>
    <th class="grid-header-container"
      *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
      [ngStyle]="{'min-width': taskDocumentsDataForGridData.width, 'max-width': taskDocumentsDataForGridData.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
      class="sticky-dynamic-col1">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>{{taskDocumentsDataForGridData.fieldColumnarray}}</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <th id="menu" class="sticky-col first-col"></th>
    <!-- search input row is added -->
    <tr>
      <td [class]="
              makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''
            "></td>
      <td *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
        [ngStyle]="{'min-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200,'max-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200}"
        class="sticky-dynamic-col1">
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
        </div>
      </td>
    </tr>
    <!-- data row -->
    <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
      [class.highlightRow]="list.childCheckBoxs == true">
      <td style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
              (change)="dataGridChildCheckBoxChecked($event, list, idx)">
          </div>
        </div>
      </td>
      <td *ngFor="let key of columnLists.columnsListarray1; let i = index;" (focus)="focusEmpty()"
        class="sticky-dynamic-row1" (mouseover)="cssfunction(i)" matTooltipClass="tooltip-withoutbreak"
        [matTooltip]="list[key.columnsListarray] === 'htmlClobView' ? '' : list[key.columnsListarray]"
        [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
        <span *ngIf="list[key.columnsListarray]=='fileIspresentsa' || list[key.columnsListarray]=='fileIspresentsa'">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="downloadTemplates(list,key.columnsListarray)">

              <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
              <span class="ms-1">View</span>
            </button>
          </div>
        </span>
        <span *ngIf="key.dataType=='CHECKBOX'">
          <div class="gridCheckBoxes">
            <img *ngIf="list[key.columnsListarray]" src="../../../assets/img/cr_module/accessSymbol.svg" width="16"
              height="16" alt="access" />
            <img *ngIf="list[key.columnsListarray] == false" src="../../../assets/img/cr_module/noAcessSymbol.svg"
              width="16" height="16" alt="no access" />
          </div>
        </span>
        <span class="content-wrapper" *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' &&
         list[key.columnsListarray] !='htmlClobView' &&
         list[key.columnsListarray] !='fileIspresentsa' &&
         list[key.columnsListarray] !='fileIsNotpresentsa'">

          {{ list[key.columnsListarray] }}

          <i *ngIf="key.columnsListarray=='CONTENT_NAME'" class="fa fa-eye eye-icon-overlay" matTooltip="Preview"
            (click)="openDetailPopup(list, i)" (keydown.enter)="openDetailPopup(list, i)">
          </i>
        </span>


        <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>

        <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="getClobData(list,key.columnsListarray)">
              <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
              <span class="ms-1">View</span>
            </button>
          </div>
        </span>
      </td>
      <td class="sticky-col first-col">
        <div class="action-icons">
          <i class="fa-solid fa-pencil" matTooltip="Edit Content" style="margin-left: 5px;"
            (click)="editContentFunc(list)" (keydown.enter)="editContentFunc(list)"
            *ngIf="trainingData.saveButtonForTraining || trainingData.status === 'Published' && list.IS_QUESTION_CONTENT"></i>
          <i class="fa-sharp fa-solid fa-trash" title="Delete" style="margin-left: 5px;" (click)="openDeletePopup(list)"
            (keydown.enter)="openDeletePopup(list)" *ngIf="trainingData.saveButtonForTraining"></i>
          <i class="fa-solid fa-clipboard" title="Audit Trail" style="margin-left: 5px;"
            *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('individual',list)"
            (keydown.enter)="openAuditTrail('individual',list)"></i>
        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>

</div>
<ng-template #addOrEditContentPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{title}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer">
      <div class="row">
        <div class="col-md-6">
          <div><label for="contentName ">Content Name</label><span class="mandatory-symbol">*</span></div>
          <input id="contentName" class="input-filed-continers" type="text" [(ngModel)]="contentData.contentName"
            autocomplete="off"
            [disabled]="!(trainingData.saveButtonForTraining || (trainingData.status === 'Published' && isQuestionContent))">
          <span id="contentName-required-msg">Please enter an content name</span>
        </div>
        <div class="col-md-3">
          <div><label for="totalDuration">Total Duration</label></div>
          <input id="totalDuration" class="input-filed-continers" type="text" [(ngModel)]="contentData.totalDuration"
            (keypress)="omit_special_char($event)" autocomplete="off"
            [disabled]="!(trainingData.saveButtonForTraining || (trainingData.status === 'Published' && isQuestionContent))">
        </div>
        <div class="col-md-3">
          <div><label for="waitTime">Wait Time in Mins (Max 59)</label></div>
          <input id="waitTime" class="input-filed-continers" type="number" min="0" max="59"
            [(ngModel)]="contentData.waitTimeInMins" (keypress)="validateWaitTime($event)"
            [disabled]="!(trainingData.saveButtonForTraining || (trainingData.status === 'Published' && isQuestionContent))">
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="description">Description</label></div>
          <textarea [rows]="6" id="description" type="text" class="textarea-filed-continers" rows="4" cols="50"
            [(ngModel)]="contentData.contentDescription"
            [disabled]="!(trainingData.saveButtonForTraining || (trainingData.status === 'Published' && isQuestionContent))"></textarea>
        </div>
      </div>
      <div class="row" style="margin-top: 1%;">
        <div class="col-md-12">
          <label for="passPercentage">Content Type : </label>
          <mat-radio-group aria-label="Select an option" [(ngModel)]="contentData.isQuestionContent1"
            (change)="onTypeChanged(contentData.isQuestionContent1)"
            [disabled]="!trainingData.saveButtonForTraining||(trainingData.status === 'Published' && isQuestionContent)">
            <mat-radio-button value="Document">Document</mat-radio-button>
            <mat-radio-button value="Is Question Content?">Assessment</mat-radio-button>
          </mat-radio-group>

        </div>
      </div>
      <div class="row" *ngIf="isShowAssessmentFields">
        <div class="col-md-3">
          <div><label for="noOfQuestions">No. of Questions<span class="mandatory-symbol">*</span></label></div>
          <input id="noOfQuestions" class="input-filed-continers" type="number" min="0"
            [(ngModel)]="contentData.noOfQuestionsForAssessment" (keypress)="validateNoOfQues($event)"
            [disabled]="!(trainingData.saveButtonForTraining || (trainingData.status === 'Published' && isQuestionContent))">
             <span id="questions-required-msg">
            Please enter a valid number of questions
          </span>
        </div>
        <div class=" col-md-3">
          <div><label for="passPercentage">Pass Percentage(Max 100)<span class="mandatory-symbol">*</span></label></div>
          <input id="passPercentage" class="input-filed-continers" type="number" min="0" max="100"
            [(ngModel)]="contentData.passPercentage" (keypress)="validatePassPercentage($event)"
            [disabled]="!(trainingData.saveButtonForTraining || (trainingData.status === 'Published' && isQuestionContent))">
          <span id="passPercentage-required-msg">
            Please enter a valid pass percentage (1–100)
          </span>
        </div>
        <div class="col-md-6" [hidden]="visibleEditButton">
          <div><label for="passPercentage">Add Questions From File</label></div>
          <input type="file" class="file-input" (change)="onFileSelectedForBulkQuestions($event)"
            #fileUploadForBulkQuestion>

        </div>
      </div>
      <div class="row" *ngIf="isShowDocumentFields">
        <div class="col-md-12">
          <label for="passPercentage">Content From : </label>
          <mat-radio-group aria-label="Select an option" [(ngModel)]="contentFrom"
            (change)="onContentDocChanged(contentFrom)"
            [disabled]="!(trainingData.saveButtonForTraining || (trainingData.status === 'Published' && isQuestionContent))">
            <mat-radio-button value="Manually">Manually</mat-radio-button>
            <mat-radio-button value="Document Repository">Document Repository</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="row" *ngIf="isUploadDocManually">
        <div class="col-md-1"></div>
        <div class="col-md-6">
          <span *ngIf="!clearedContentFile && contentFile">
            <p style="display: inline-block;">Uploaded Content : {{contentData.contentName}}.{{contentData.contentExtn}}
            </p><i class="fa fa-times" (click)="removeFile()" (keydown.enter)="removeFile()"
              style="color: red;margin-left: 8px;font-size: 18px;"></i>
          </span>
          <input *ngIf="clearedContentFile || !contentFile" type="file" class="file-input"
            (change)="onFileSelected($event)" #fileUpload>
        </div>
      </div>
      <div class="row" *ngIf="isUploadDocRepository">
        <div class="col-md-1"></div>
        <div class="col-md-6">
          <span *ngIf="!clearedContentFile && contentData.documentId">
            <p style="display: inline-block;">Uploaded Content : {{contentData.documentNo}}-{{contentData.documentName}}
            </p><i *ngIf="trainingData.saveButtonForTraining" class="fa fa-times" (click)="removeFile()"
              (keydown.enter)="removeFile()" style="color: red;margin-left: 8px;font-size: 18px;"></i>
          </span>
          <button *ngIf="clearedContentFile || contentData.documentId == ''" mat-stroked-button class="addButton"
            (click)="uploadDocFromDms()">Upload</button>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="addAndEditFunction(contentData)" (keydown.enter)="addAndEditFunction(contentData)"
          *ngIf="!visibleEditButton && trainingData.saveButtonForTraining">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="addAndEditFunction(contentData)" (keydown.enter)="addAndEditFunction(contentData)"
          *ngIf="visibleEditButton && (trainingData.saveButtonForTraining || (trainingData.status === 'Published' && isQuestionContent))">
          <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
          <span class="reload_text text-white">Update</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
      <div class="row" *ngIf="isShowQuestionGrid && visibleEditButton">
        <div class="col-md-12">
          <app-content-assessment [contentData]="contentData" [trainingData]="trainingData"
            (valueChange)="changeInChild($event)"></app-content-assessment>
        </div>
      </div>
      <br>
    </div>

  </div>
</ng-template>

<ng-template #deleteContentPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <h2 mat-dialog-title>{{title }}</h2>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div><label for="deleteReason"> Reason</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteReason" rows="6" class="textarea-filed-continers" ype="text"
            [(ngModel)]="contentData.deleteReason"></textarea>
          <span id="deleteReason-required-msg">Please enter reason for delete</span>
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #reorderContentPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReorderFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{title}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <b>Drag and drop to reorder the content sequence</b>
    <div class="table-container"  style="max-height: 50vh; overflow-y: auto;">
      <table class="dynamic-table-container">
        <th style="width: 80px; text-align: center;overflow: hidden;text-overflow: 'ellipsis';
      white-space: 'nowrap'"> <span>Content Seq</span> <span class="grid-header-container"></span> </th>
        <th style="width: 240px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
      white-space: 'nowrap'"> <span>Name</span> <span class="grid-header-container"></span> </th>
        <th style="width: 80px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
      white-space: 'nowrap'"> <span>New Seq</span> <span class="grid-header-container"></span> </th>

        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
          <tr cdkDrag cdkDragLockAxis="y" cdkDragHandle *ngFor="let content of contentList let idx = index;">
            <td style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"><span>{{content.contentSeq}}</span></td>
            <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
         white-space: 'nowrap'"><span>{{content.contentName}}</span></td>
            <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"><span>{{content.newSeq}}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="reorderContentFunction()">
        <i class="fa fa-redorder"></i> Reorder
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelReorderFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #addDocumentPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddDocuemntFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{title}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer">
      <app-folder-stucture [data]="'TRAINING'"
        (valueChange)="changeInFolderStructureChild($event)"></app-folder-stucture>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addDocumentFromDmsFunction()">
      <i class="fas fa-plus"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddDocuemntFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #switchConfirmPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <h2 mat-dialog-title>Confirmation</h2>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          {{switchMessage}}
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="switchConfirmFunction()">
        OK
      </button>
    </div>
  </div>
</ng-template>
<ng-template #viewPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelViewPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> View </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <web-viewer [data]="viewerData" (oneQmsListener)="onUserActivity()"></web-viewer>
  </div>
</ng-template>
<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-editor #clobViewPopup></app-editor>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
